import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as classes from './classes.module.scss';
import { rulersForDpi } from '../../config/dpi';

export default class Ruler extends PureComponent {
  static propTypes = {
    pos: PropTypes.number.isRequired,
    center: PropTypes.number.isRequired,
    dpi: PropTypes.number.isRequired,
    maxLastTick: PropTypes.number.isRequired
  };

  renderTicks() {
    const {
      pos, dpi, maxLastTick
    } = this.props;
    const {
      step, labelStep, labelStepCm, stepCm
    } = rulersForDpi(dpi);
    const firstTick = Math.max(Math.ceil(pos / step) * step, 0);
    const lastTick = maxLastTick;
    let tick = lastTick;
    let tickCm = Math.round(tick * 2.54);
    let labelTick = maxLastTick - lastTick;
    let labelTickCm = Math.round(labelTick * 2.54);
    const res = [];
    while (tick >= firstTick) {
      let label = null;
      const top = (tick - pos);
      const topCm = tickCm - pos * 2.54;
      let style;
      if (window.currentLocale.unit === 'cm') {
        style = { top: topCm * dpi / 2.54 };
        if (labelTickCm % labelStepCm === 0) {
          label = labelTickCm;
        }
      } else {
        style = { top: top * dpi };
        if (labelTick % labelStep === 0) {
          label = labelTick;
        }
      }
      const className = classnames(
        classes.tickV,
        { [classes.labeledTickV]: label !== null }
      );

      res.push(
        <div className={ className } style={ style } key={ tick }>
          { label }
        </div>
      );
      tick -= step;
      tickCm -= stepCm;
      labelTick += step;
      labelTickCm += stepCm;
    }
    return res;
  }

  render() {
    return (
      <div className={ classes.rulerV }>
        { this.renderTicks() }
      </div>
    );
  }
}
